import { useMemo } from 'react'
import { calculateAverageRating, getTotalReviews, formatRating, getRatingDistribution, type StarCounts } from '@mrb91002/shared-types'

export function useRating(starCounts: StarCounts | undefined) {
  return useMemo(() => {
    const safeCounts = starCounts || { '1': 0, '2': 0, '3': 0, '4': 0, '5': 0 }
    return {
      averageRating: calculateAverageRating(safeCounts),
      totalReviews: getTotalReviews(safeCounts),
      formattedRating: formatRating(safeCounts),
      distribution: getRatingDistribution(safeCounts)
    }
  }, [starCounts])
}